import { Inject, Injectable, Injector } from '@angular/core';


import { FootprintEdi_datex_adjustment_info_json_to_xmlService } from './FootprintEdi.flow.index';
import { FootprintEdi_datex_adjustment_info_xml_to_jsonService } from './FootprintEdi.flow.index';
import { FootprintEdi_datex_order_info_json_to_xmlService } from './FootprintEdi.flow.index';
import { FootprintEdi_datex_order_info_xml_to_jsonService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_alerts_mainService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_cancel_ordersService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_clean_inventory_snapshotService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_confirm_entity_importService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_confirm_entity_import_message_updatesService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_datex_order_info_submitService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_delete_wavelength_transmissionsService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_export_completed_shipmentsService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_export_inventory_adjustmentsService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_export_inventory_snapshotService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_generate_serials_payloadService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_get_completed_shipmentsService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_get_inventory_adjustmentsService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_get_map_filtersService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_process_entity_import_contentService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_process_entity_import_deploy_configService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_revisionsService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_set_wavelength_connector_transmissionService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_sftp_pull_and_submitService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_sftp_pushService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_submit_datex_material_info_jsonService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_submit_datex_order_info_jsonService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_submit_datex_order_info_xmlService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_submit_entity_import_xml_requestService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_translate_datex_info_xml_to_entity_importService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_validate_materialsService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_x12_940_mapService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_x12_945_mapService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_x12_947_mapService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_x12_xml_to_jsonService } from './FootprintEdi.flow.index';
import { FootprintEdi_edi_xml_egressService } from './FootprintEdi.flow.index';
import { FootprintEdi_entity_import_json_to_xmlService } from './FootprintEdi.flow.index';
import { FootprintEdi_footprint_generic_json_adjustment_export_to_xmlService } from './FootprintEdi.flow.index';
import { FootprintEdi_footprint_generic_json_inventory_export_dataService } from './FootprintEdi.flow.index';
import { FootprintEdi_footprint_generic_json_inventory_export_to_xmlService } from './FootprintEdi.flow.index';
import { FootprintEdi_footprint_generic_json_order_export_dataService } from './FootprintEdi.flow.index';
import { FootprintEdi_footprint_generic_json_order_export_to_xmlService } from './FootprintEdi.flow.index';
import { FootprintEdi_footprint_manage_wavelength_transmissionsService } from './FootprintEdi.flow.index';
import { FootprintEdi_logs_writeService } from './FootprintEdi.flow.index';
import { FootprintEdi_map_datex_order_info_to_x12_4010_945Service } from './FootprintEdi.flow.index';
import { FootprintEdi_map_datex_order_info_to_x12_5010_945Service } from './FootprintEdi.flow.index';
import { FootprintEdi_map_x12_4010_940_to_datex_order_infoService } from './FootprintEdi.flow.index';
import { FootprintEdi_map_x12_4010_947_to_datex_adjustment_infoService } from './FootprintEdi.flow.index';
import { FootprintEdi_map_x12_5010_940_to_datex_order_infoService } from './FootprintEdi.flow.index';
import { FootprintEdi_messages_updateService } from './FootprintEdi.flow.index';
import { FootprintEdi_messages_writeService } from './FootprintEdi.flow.index';
import { FootprintEdi_rabbit_mq_pushService } from './FootprintEdi.flow.index';
import { FootprintEdi_sftp_pullService } from './FootprintEdi.flow.index';
import { FootprintEdi_sftp_pushService } from './FootprintEdi.flow.index';
import { FootprintEdi_uom_convertService } from './FootprintEdi.flow.index';
import { FootprintEdi_uom_readService } from './FootprintEdi.flow.index';
import { FootprintEdi_uom_testsService } from './FootprintEdi.flow.index';
import { FootprintEdi_uom_writeService } from './FootprintEdi.flow.index';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_FlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootprintEdi: FootprintEdi_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _datex_adjustment_info_json_to_xml: FootprintEdi_datex_adjustment_info_json_to_xmlService;
  public async datex_adjustment_info_json_to_xml($inParams: { DatexAdjustmentInfo?: $frontendTypes.FootprintEdi.DatexAdjustmentInfo }): Promise< { DatexAdjustmentInfo?: string }> {
    if(!this._datex_adjustment_info_json_to_xml) { 
      this._datex_adjustment_info_json_to_xml = this.injector.get(FootprintEdi_datex_adjustment_info_json_to_xmlService);
    }
    return this._datex_adjustment_info_json_to_xml.run($inParams);
  }
   
   

   
 
  private _datex_adjustment_info_xml_to_json: FootprintEdi_datex_adjustment_info_xml_to_jsonService;
  public async datex_adjustment_info_xml_to_json($inParams: { DatexAdjustmentInfo?: string }): Promise< { DatexAdjustmentInfo?: $frontendTypes.FootprintEdi.DatexAdjustmentInfo }> {
    if(!this._datex_adjustment_info_xml_to_json) { 
      this._datex_adjustment_info_xml_to_json = this.injector.get(FootprintEdi_datex_adjustment_info_xml_to_jsonService);
    }
    return this._datex_adjustment_info_xml_to_json.run($inParams);
  }
   
   

   
 
  private _datex_order_info_json_to_xml: FootprintEdi_datex_order_info_json_to_xmlService;
  public async datex_order_info_json_to_xml($inParams: { DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }): Promise< { DatexOrderInfo?: string }> {
    if(!this._datex_order_info_json_to_xml) { 
      this._datex_order_info_json_to_xml = this.injector.get(FootprintEdi_datex_order_info_json_to_xmlService);
    }
    return this._datex_order_info_json_to_xml.run($inParams);
  }
   
   

   
 
  private _datex_order_info_xml_to_json: FootprintEdi_datex_order_info_xml_to_jsonService;
  public async datex_order_info_xml_to_json($inParams: { DatexOrderInfo?: string }): Promise< { DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }> {
    if(!this._datex_order_info_xml_to_json) { 
      this._datex_order_info_xml_to_json = this.injector.get(FootprintEdi_datex_order_info_xml_to_jsonService);
    }
    return this._datex_order_info_xml_to_json.run($inParams);
  }
   
   

   
 
  private _edi_alerts_main: FootprintEdi_edi_alerts_mainService;
  public async edi_alerts_main($inParams: { days?: number, retry?: boolean, output?: boolean }): Promise< { messages?: any[] }> {
    if(!this._edi_alerts_main) { 
      this._edi_alerts_main = this.injector.get(FootprintEdi_edi_alerts_mainService);
    }
    return this._edi_alerts_main.run($inParams);
  }
   
   

   
 
  private _edi_cancel_orders: FootprintEdi_edi_cancel_ordersService;
  public async edi_cancel_orders($inParams: { orders: { order_id: number, order_class_id: number, order_type_id: number, order_status_id: number, order_notes: string }[] }): Promise< { success?: boolean, messages?: any[], error?: string, order_ids?: number[] }> {
    if(!this._edi_cancel_orders) { 
      this._edi_cancel_orders = this.injector.get(FootprintEdi_edi_cancel_ordersService);
    }
    return this._edi_cancel_orders.run($inParams);
  }
   
   

   
 
  private _edi_clean_inventory_snapshot: FootprintEdi_edi_clean_inventory_snapshotService;
  public async edi_clean_inventory_snapshot($inParams: { payload?: string }): Promise< { payload?: string }> {
    if(!this._edi_clean_inventory_snapshot) { 
      this._edi_clean_inventory_snapshot = this.injector.get(FootprintEdi_edi_clean_inventory_snapshotService);
    }
    return this._edi_clean_inventory_snapshot.run($inParams);
  }
   
   

   
 
  private _edi_confirm_entity_import: FootprintEdi_edi_confirm_entity_importService;
  public async edi_confirm_entity_import($inParams: {  }): Promise< { success?: boolean, messages?: string[], count?: number }> {
    if(!this._edi_confirm_entity_import) { 
      this._edi_confirm_entity_import = this.injector.get(FootprintEdi_edi_confirm_entity_importService);
    }
    return this._edi_confirm_entity_import.run($inParams);
  }
   
   

   
 
  private _edi_confirm_entity_import_message_updates: FootprintEdi_edi_confirm_entity_import_message_updatesService;
  public async edi_confirm_entity_import_message_updates($inParams: { message?: $frontendTypes.Utilities.Message, status_code?: string, summary?: string, error_message?: string }): Promise<void> {
    if(!this._edi_confirm_entity_import_message_updates) { 
      this._edi_confirm_entity_import_message_updates = this.injector.get(FootprintEdi_edi_confirm_entity_import_message_updatesService);
    }
    return this._edi_confirm_entity_import_message_updates.run($inParams);
  }
   
   

   
 
  private _edi_datex_order_info_submit: FootprintEdi_edi_datex_order_info_submitService;
  public async edi_datex_order_info_submit($inParams: { integration_id?: string, datex_order_info_xml?: string }): Promise< { request_id?: string, entity_import?: any }> {
    if(!this._edi_datex_order_info_submit) { 
      this._edi_datex_order_info_submit = this.injector.get(FootprintEdi_edi_datex_order_info_submitService);
    }
    return this._edi_datex_order_info_submit.run($inParams);
  }
   
   

   
 
  private _edi_delete_wavelength_transmissions: FootprintEdi_edi_delete_wavelength_transmissionsService;
  public async edi_delete_wavelength_transmissions($inParams: { entity: string, id: number, transaction_id?: string, transmission_type: string, transmission_direction: string }): Promise< { success?: boolean, messages?: string[], transmission_id?: number }> {
    if(!this._edi_delete_wavelength_transmissions) { 
      this._edi_delete_wavelength_transmissions = this.injector.get(FootprintEdi_edi_delete_wavelength_transmissionsService);
    }
    return this._edi_delete_wavelength_transmissions.run($inParams);
  }
   
   

   
 
  private _edi_export_completed_shipments: FootprintEdi_edi_export_completed_shipmentsService;
  public async edi_export_completed_shipments($inParams: { project_lookups?: string[], project_ids?: number[], days?: number, shipment_type?: number, transaction_type?: string, has_order_transmissions?: boolean, in_transmission_type?: string, integration_id?: string }): Promise< { messages?: any[] }> {
    if(!this._edi_export_completed_shipments) { 
      this._edi_export_completed_shipments = this.injector.get(FootprintEdi_edi_export_completed_shipmentsService);
    }
    return this._edi_export_completed_shipments.run($inParams);
  }
   
   

   
 
  private _edi_export_inventory_adjustments: FootprintEdi_edi_export_inventory_adjustmentsService;
  public async edi_export_inventory_adjustments($inParams: { owner_lookup?: string, project_lookup: string, integration_id: string, transaction_type: string, transaction_id?: string, days?: number, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean }, operation_codes?: string[] }): Promise< { messages?: any[] }> {
    if(!this._edi_export_inventory_adjustments) { 
      this._edi_export_inventory_adjustments = this.injector.get(FootprintEdi_edi_export_inventory_adjustmentsService);
    }
    return this._edi_export_inventory_adjustments.run($inParams);
  }
   
   

   
 
  private _edi_export_inventory_snapshot: FootprintEdi_edi_export_inventory_snapshotService;
  public async edi_export_inventory_snapshot($inParams: { owner_lookup?: string, project_lookup: string, integration_id: string, transaction_type: string, transaction_id?: string, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean, only_inventory?: boolean, only_physical?: boolean, date_format?: string } }): Promise< { messages?: any[] }> {
    if(!this._edi_export_inventory_snapshot) { 
      this._edi_export_inventory_snapshot = this.injector.get(FootprintEdi_edi_export_inventory_snapshotService);
    }
    return this._edi_export_inventory_snapshot.run($inParams);
  }
   
   

   
 
  private _edi_generate_serials_payload: FootprintEdi_edi_generate_serials_payloadService;
  public async edi_generate_serials_payload($inParams: { quantity?: number, packaging_name?: string, packaging_short_name?: string, net_weight?: number, gross_weight?: number, weight_uom?: string, net_volume?: number, gross_volume?: number, volume_uom?: string, udfs?: $frontendTypes.FootprintEdi.UserDefinedField[], notes?: string }): Promise< { SerialNumbers?: $frontendTypes.FootprintEdi.SerialNumber[] }> {
    if(!this._edi_generate_serials_payload) { 
      this._edi_generate_serials_payload = this.injector.get(FootprintEdi_edi_generate_serials_payloadService);
    }
    return this._edi_generate_serials_payload.run($inParams);
  }
   
   

   
 
  private _edi_get_completed_shipments: FootprintEdi_edi_get_completed_shipmentsService;
  public async edi_get_completed_shipments($inParams: { project_lookups?: string[], project_ids?: number[], days?: number, shipment_type?: number, transaction_type?: string, has_order_transmissions?: boolean, in_transmission_type?: string, out_transmission_type?: string, integration_id?: string }): Promise< { orders?: { transaction_id?: string, DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }[], messages?: any[] }> {
    if(!this._edi_get_completed_shipments) { 
      this._edi_get_completed_shipments = this.injector.get(FootprintEdi_edi_get_completed_shipmentsService);
    }
    return this._edi_get_completed_shipments.run($inParams);
  }
   
   

   
 
  private _edi_get_inventory_adjustments: FootprintEdi_edi_get_inventory_adjustmentsService;
  public async edi_get_inventory_adjustments($inParams: { project_lookups: string[], integration_id: string, transaction_type: string, transaction_id?: string, days?: number, render_options?: { lots?: boolean, license_plates?: boolean, serial_numbers?: boolean }, operation_codes?: string[], in_transmission_type?: string, out_transmission_type?: string, project_ids?: number[], include_move_tasks?: boolean, take?: number }): Promise< { adjsutments?: { transaction_id?: string, DatexAdjustmentInfo?: $frontendTypes.FootprintEdi.DatexAdjustmentInfo }[], messages?: any[] }> {
    if(!this._edi_get_inventory_adjustments) { 
      this._edi_get_inventory_adjustments = this.injector.get(FootprintEdi_edi_get_inventory_adjustmentsService);
    }
    return this._edi_get_inventory_adjustments.run($inParams);
  }
   
   

   
 
  private _edi_get_map_filters: FootprintEdi_edi_get_map_filtersService;
  public async edi_get_map_filters($inParams: { datex_order_info?: $frontendTypes.FootprintEdi.DatexOrderInfo, datex_adjustment_info?: $frontendTypes.FootprintEdi.DatexAdjustmentInfo, datex_inventory_info?: $frontendTypes.FootprintEdi.DatexInventoryInfo, transaction_type: string }): Promise< { map_filters?: any, skip?: boolean, integration_id?: string }> {
    if(!this._edi_get_map_filters) { 
      this._edi_get_map_filters = this.injector.get(FootprintEdi_edi_get_map_filtersService);
    }
    return this._edi_get_map_filters.run($inParams);
  }
   
   

   
 
  private _edi_process_entity_import_content: FootprintEdi_edi_process_entity_import_contentService;
  public async edi_process_entity_import_content($inParams: { integration_id?: string, entity_import_content?: string, transaction_id?: string }): Promise< { results?: any[], entity_import_content?: string, validation_results?: { level?: number, message?: string }[], do_not_submit?: boolean }> {
    if(!this._edi_process_entity_import_content) { 
      this._edi_process_entity_import_content = this.injector.get(FootprintEdi_edi_process_entity_import_contentService);
    }
    return this._edi_process_entity_import_content.run($inParams);
  }
   
   

   
 
  private _edi_process_entity_import_deploy_config: FootprintEdi_edi_process_entity_import_deploy_configService;
  public async edi_process_entity_import_deploy_config($inParams: {  }): Promise< { results?: any[] }> {
    if(!this._edi_process_entity_import_deploy_config) { 
      this._edi_process_entity_import_deploy_config = this.injector.get(FootprintEdi_edi_process_entity_import_deploy_configService);
    }
    return this._edi_process_entity_import_deploy_config.run($inParams);
  }
   
   

   
 
  private _edi_revisions: FootprintEdi_edi_revisionsService;
  public async edi_revisions($inParams: { owner_lookups?: string[], project_lookups?: string[], type_id?: number, options?: { lookup_code?: boolean, owner_reference?: boolean, vendor_reference?: boolean, only_created?: boolean, output_data?: boolean }, days?: number, minutes?: number }): Promise< { output?: any[] }> {
    if(!this._edi_revisions) { 
      this._edi_revisions = this.injector.get(FootprintEdi_edi_revisionsService);
    }
    return this._edi_revisions.run($inParams);
  }
   
   

   
 
  private _edi_set_wavelength_connector_transmission: FootprintEdi_edi_set_wavelength_connector_transmissionService;
  public async edi_set_wavelength_connector_transmission($inParams: { shipment_id?: number, integration_id: string, transaction_id: string, transaction_type?: string, file_content: string }): Promise< { messages?: any[] }> {
    if(!this._edi_set_wavelength_connector_transmission) { 
      this._edi_set_wavelength_connector_transmission = this.injector.get(FootprintEdi_edi_set_wavelength_connector_transmissionService);
    }
    return this._edi_set_wavelength_connector_transmission.run($inParams);
  }
   
   

   
 
  private _edi_sftp_pull_and_submit: FootprintEdi_edi_sftp_pull_and_submitService;
  public async edi_sftp_pull_and_submit($inParams: { integration_id: string, sftp_connection: string, sftp_path: string, sftp_extension?: string }): Promise< { messages?: any[] }> {
    if(!this._edi_sftp_pull_and_submit) { 
      this._edi_sftp_pull_and_submit = this.injector.get(FootprintEdi_edi_sftp_pull_and_submitService);
    }
    return this._edi_sftp_pull_and_submit.run($inParams);
  }
   
   

   
 
  private _edi_sftp_push: FootprintEdi_edi_sftp_pushService;
  public async edi_sftp_push($inParams: { connection: string, target_path: string, file_content: string, transaction_type?: string }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._edi_sftp_push) { 
      this._edi_sftp_push = this.injector.get(FootprintEdi_edi_sftp_pushService);
    }
    return this._edi_sftp_push.run($inParams);
  }
   
   

   
 
  private _edi_submit_datex_material_info_json: FootprintEdi_edi_submit_datex_material_info_jsonService;
  public async edi_submit_datex_material_info_json($inParams: { datex_material_info?: $frontendTypes.FootprintEdi.DatexMaterialInfo, transaction_id?: string }): Promise< { result?: any }> {
    if(!this._edi_submit_datex_material_info_json) { 
      this._edi_submit_datex_material_info_json = this.injector.get(FootprintEdi_edi_submit_datex_material_info_jsonService);
    }
    return this._edi_submit_datex_material_info_json.run($inParams);
  }
   
   

   
 
  private _edi_submit_datex_order_info_json: FootprintEdi_edi_submit_datex_order_info_jsonService;
  public async edi_submit_datex_order_info_json($inParams: { datex_order_info?: $frontendTypes.FootprintEdi.DatexOrderInfo, transaction_id?: string }): Promise< { result?: any }> {
    if(!this._edi_submit_datex_order_info_json) { 
      this._edi_submit_datex_order_info_json = this.injector.get(FootprintEdi_edi_submit_datex_order_info_jsonService);
    }
    return this._edi_submit_datex_order_info_json.run($inParams);
  }
   
   

   
 
  private _edi_submit_datex_order_info_xml: FootprintEdi_edi_submit_datex_order_info_xmlService;
  public async edi_submit_datex_order_info_xml($inParams: { DatexOrderInfo?: string }): Promise< { Result?: any }> {
    if(!this._edi_submit_datex_order_info_xml) { 
      this._edi_submit_datex_order_info_xml = this.injector.get(FootprintEdi_edi_submit_datex_order_info_xmlService);
    }
    return this._edi_submit_datex_order_info_xml.run($inParams);
  }
   
   

   
 
  private _edi_submit_entity_import_xml_request: FootprintEdi_edi_submit_entity_import_xml_requestService;
  public async edi_submit_entity_import_xml_request($inParams: { integration_id?: string, entity_import_content?: string, transaction_id?: string }): Promise< { request_id?: string, validation_result?: { level?: number, message?: string }[] }> {
    if(!this._edi_submit_entity_import_xml_request) { 
      this._edi_submit_entity_import_xml_request = this.injector.get(FootprintEdi_edi_submit_entity_import_xml_requestService);
    }
    return this._edi_submit_entity_import_xml_request.run($inParams);
  }
   
   

   
 
  private _edi_translate_datex_info_xml_to_entity_import: FootprintEdi_edi_translate_datex_info_xml_to_entity_importService;
  public async edi_translate_datex_info_xml_to_entity_import($inParams: { integration_id?: string, transaction_id?: string, correlation_id?: string, transaction_type?: string, datex_order_info?: string }): Promise< { entity_import?: string }> {
    if(!this._edi_translate_datex_info_xml_to_entity_import) { 
      this._edi_translate_datex_info_xml_to_entity_import = this.injector.get(FootprintEdi_edi_translate_datex_info_xml_to_entity_importService);
    }
    return this._edi_translate_datex_info_xml_to_entity_import.run($inParams);
  }
   
   

   
 
  private _edi_validate_materials: FootprintEdi_edi_validate_materialsService;
  public async edi_validate_materials($inParams: { project_lookup: string, upc_codes?: string[], owner_lookup?: string, materials?: { lookup_code?: string, packaging?: string }[] }): Promise< { error?: string }> {
    if(!this._edi_validate_materials) { 
      this._edi_validate_materials = this.injector.get(FootprintEdi_edi_validate_materialsService);
    }
    return this._edi_validate_materials.run($inParams);
  }
   
   

   
 
  private _edi_x12_940_map: FootprintEdi_edi_x12_940_mapService;
  public async edi_x12_940_map($inParams: { integration_id?: string, transaction_id?: string, correlation_id?: string, transaction_type?: string, x12_xml?: string }): Promise< { datex_order_info?: string }> {
    if(!this._edi_x12_940_map) { 
      this._edi_x12_940_map = this.injector.get(FootprintEdi_edi_x12_940_mapService);
    }
    return this._edi_x12_940_map.run($inParams);
  }
   
   

   
 
  private _edi_x12_945_map: FootprintEdi_edi_x12_945_mapService;
  public async edi_x12_945_map($inParams: { integration_id?: string, transaction_id?: string, correlation_id?: string, transaction_type?: string, datex_order_info?: string }): Promise< { x12_xml?: string }> {
    if(!this._edi_x12_945_map) { 
      this._edi_x12_945_map = this.injector.get(FootprintEdi_edi_x12_945_mapService);
    }
    return this._edi_x12_945_map.run($inParams);
  }
   
   

   
 
  private _edi_x12_947_map: FootprintEdi_edi_x12_947_mapService;
  public async edi_x12_947_map($inParams: { integration_id?: string, transaction_id?: string, correlation_id?: string, transaction_type?: string, x12_xml?: string }): Promise< { datex_order_info?: string }> {
    if(!this._edi_x12_947_map) { 
      this._edi_x12_947_map = this.injector.get(FootprintEdi_edi_x12_947_mapService);
    }
    return this._edi_x12_947_map.run($inParams);
  }
   
   

   
 
  private _edi_x12_xml_to_json: FootprintEdi_edi_x12_xml_to_jsonService;
  public async edi_x12_xml_to_json($inParams: { XML?: string }): Promise< { JSON?: any, Results?: any[] }> {
    if(!this._edi_x12_xml_to_json) { 
      this._edi_x12_xml_to_json = this.injector.get(FootprintEdi_edi_x12_xml_to_jsonService);
    }
    return this._edi_x12_xml_to_json.run($inParams);
  }
   
   

   
 
  private _edi_xml_egress: FootprintEdi_edi_xml_egressService;
  public async edi_xml_egress($inParams: { integration_id?: string, transaction_id?: string, correlation_id?: string, file_content?: string, document_type?: string, reference_number?: string, subject?: string }): Promise< { results?: any[], success?: boolean }> {
    if(!this._edi_xml_egress) { 
      this._edi_xml_egress = this.injector.get(FootprintEdi_edi_xml_egressService);
    }
    return this._edi_xml_egress.run($inParams);
  }
   
   

   
 
  private _entity_import_json_to_xml: FootprintEdi_entity_import_json_to_xmlService;
  public async entity_import_json_to_xml($inParams: { entity_import_json?: any, transaction_id?: string }): Promise< { entity_import_xml?: string }> {
    if(!this._entity_import_json_to_xml) { 
      this._entity_import_json_to_xml = this.injector.get(FootprintEdi_entity_import_json_to_xmlService);
    }
    return this._entity_import_json_to_xml.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_adjustment_export_to_xml: FootprintEdi_footprint_generic_json_adjustment_export_to_xmlService;
  public async footprint_generic_json_adjustment_export_to_xml($inParams: { DatexAdjustmentInfo?: $frontendTypes.FootprintApiManager.DatexAdjustmentInfo }): Promise< { DatexAdjustmentInfoXml?: string }> {
    if(!this._footprint_generic_json_adjustment_export_to_xml) { 
      this._footprint_generic_json_adjustment_export_to_xml = this.injector.get(FootprintEdi_footprint_generic_json_adjustment_export_to_xmlService);
    }
    return this._footprint_generic_json_adjustment_export_to_xml.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_inventory_export_data: FootprintEdi_footprint_generic_json_inventory_export_dataService;
  public async footprint_generic_json_inventory_export_data($inParams: { project_lookup_code?: string, material_lookup_code?: string, warehouse_name?: string, render_lots?: boolean, render_license_plates?: boolean, render_serial_numbers?: boolean, debug?: boolean, only_inventory?: boolean, only_physical?: boolean, date_format?: string }): Promise< { DatexInventoryInfo?: { Projects?: any[], Warehouses?: any[] }, messages?: any[] }> {
    if(!this._footprint_generic_json_inventory_export_data) { 
      this._footprint_generic_json_inventory_export_data = this.injector.get(FootprintEdi_footprint_generic_json_inventory_export_dataService);
    }
    return this._footprint_generic_json_inventory_export_data.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_inventory_export_to_xml: FootprintEdi_footprint_generic_json_inventory_export_to_xmlService;
  public async footprint_generic_json_inventory_export_to_xml($inParams: { DatexInventoryInfo?: $frontendTypes.FootprintApiManager.DatexInventoryInfo }): Promise< { DatexInventoryInfoXml?: string }> {
    if(!this._footprint_generic_json_inventory_export_to_xml) { 
      this._footprint_generic_json_inventory_export_to_xml = this.injector.get(FootprintEdi_footprint_generic_json_inventory_export_to_xmlService);
    }
    return this._footprint_generic_json_inventory_export_to_xml.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_export_data: FootprintEdi_footprint_generic_json_order_export_dataService;
  public async footprint_generic_json_order_export_data($inParams: { shipmentId?: number, orderId?: number, dateFormat?: string }): Promise< { DatexOrderInfo?: $frontendTypes.FootprintApiManager.DatexOrderInfo, orderId?: number }> {
    if(!this._footprint_generic_json_order_export_data) { 
      this._footprint_generic_json_order_export_data = this.injector.get(FootprintEdi_footprint_generic_json_order_export_dataService);
    }
    return this._footprint_generic_json_order_export_data.run($inParams);
  }
   
   

   
 
  private _footprint_generic_json_order_export_to_xml: FootprintEdi_footprint_generic_json_order_export_to_xmlService;
  public async footprint_generic_json_order_export_to_xml($inParams: { DatexOrderInfo?: $frontendTypes.FootprintApiManager.DatexOrderInfo }): Promise< { DatexOrderInfoXml?: string }> {
    if(!this._footprint_generic_json_order_export_to_xml) { 
      this._footprint_generic_json_order_export_to_xml = this.injector.get(FootprintEdi_footprint_generic_json_order_export_to_xmlService);
    }
    return this._footprint_generic_json_order_export_to_xml.run($inParams);
  }
   
   

   
 
  private _footprint_manage_wavelength_transmissions: FootprintEdi_footprint_manage_wavelength_transmissionsService;
  public async footprint_manage_wavelength_transmissions($inParams: { entity: string, id: number, action: string, transaction_id?: string, integration_id?: string, transmission_type?: string, transmission_direction?: string, notes?: string, transmission_id?: number, type_id?: number, integration_name?: string }): Promise< { success?: boolean, messages?: string[], transmission_id?: number }> {
    if(!this._footprint_manage_wavelength_transmissions) { 
      this._footprint_manage_wavelength_transmissions = this.injector.get(FootprintEdi_footprint_manage_wavelength_transmissionsService);
    }
    return this._footprint_manage_wavelength_transmissions.run($inParams);
  }
   
   

   
 
  private _logs_write: FootprintEdi_logs_writeService;
  public async logs_write($inParams: { input?: $frontendTypes.Utilities.Log[] }): Promise< { output?: { log_id?: string }[], success?: boolean, error?: any[] }> {
    if(!this._logs_write) { 
      this._logs_write = this.injector.get(FootprintEdi_logs_writeService);
    }
    return this._logs_write.run($inParams);
  }
   
   

   
 
  private _map_datex_order_info_to_x12_4010_945: FootprintEdi_map_datex_order_info_to_x12_4010_945Service;
  public async map_datex_order_info_to_x12_4010_945($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise< { X12?: $frontendTypes.FootprintEdi.X12_00401_945[] }> {
    if(!this._map_datex_order_info_to_x12_4010_945) { 
      this._map_datex_order_info_to_x12_4010_945 = this.injector.get(FootprintEdi_map_datex_order_info_to_x12_4010_945Service);
    }
    return this._map_datex_order_info_to_x12_4010_945.run($inParams);
  }
   
   

   
 
  private _map_datex_order_info_to_x12_5010_945: FootprintEdi_map_datex_order_info_to_x12_5010_945Service;
  public async map_datex_order_info_to_x12_5010_945($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise< { X12?: $frontendTypes.FootprintEdi.X12_00501_945[] }> {
    if(!this._map_datex_order_info_to_x12_5010_945) { 
      this._map_datex_order_info_to_x12_5010_945 = this.injector.get(FootprintEdi_map_datex_order_info_to_x12_5010_945Service);
    }
    return this._map_datex_order_info_to_x12_5010_945.run($inParams);
  }
   
   

   
 
  private _map_x12_4010_940_to_datex_order_info: FootprintEdi_map_x12_4010_940_to_datex_order_infoService;
  public async map_x12_4010_940_to_datex_order_info($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise< { DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }> {
    if(!this._map_x12_4010_940_to_datex_order_info) { 
      this._map_x12_4010_940_to_datex_order_info = this.injector.get(FootprintEdi_map_x12_4010_940_to_datex_order_infoService);
    }
    return this._map_x12_4010_940_to_datex_order_info.run($inParams);
  }
   
   

   
 
  private _map_x12_4010_947_to_datex_adjustment_info: FootprintEdi_map_x12_4010_947_to_datex_adjustment_infoService;
  public async map_x12_4010_947_to_datex_adjustment_info($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise< { DatexAdjustmentInfo?: $frontendTypes.FootprintEdi.DatexAdjustmentInfo, results?: any[] }> {
    if(!this._map_x12_4010_947_to_datex_adjustment_info) { 
      this._map_x12_4010_947_to_datex_adjustment_info = this.injector.get(FootprintEdi_map_x12_4010_947_to_datex_adjustment_infoService);
    }
    return this._map_x12_4010_947_to_datex_adjustment_info.run($inParams);
  }
   
   

   
 
  private _map_x12_5010_940_to_datex_order_info: FootprintEdi_map_x12_5010_940_to_datex_order_infoService;
  public async map_x12_5010_940_to_datex_order_info($inParams: { XML?: string, Data?: $frontendTypes.FootprintEdi.DatexMapInfo }): Promise< { DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }> {
    if(!this._map_x12_5010_940_to_datex_order_info) { 
      this._map_x12_5010_940_to_datex_order_info = this.injector.get(FootprintEdi_map_x12_5010_940_to_datex_order_infoService);
    }
    return this._map_x12_5010_940_to_datex_order_info.run($inParams);
  }
   
   

   
 
  private _messages_update: FootprintEdi_messages_updateService;
  public async messages_update($inParams: { input?: $frontendTypes.Utilities.Message[] }): Promise< { success?: boolean, error?: any[] }> {
    if(!this._messages_update) { 
      this._messages_update = this.injector.get(FootprintEdi_messages_updateService);
    }
    return this._messages_update.run($inParams);
  }
   
   

   
 
  private _messages_write: FootprintEdi_messages_writeService;
  public async messages_write($inParams: { input?: $frontendTypes.Utilities.Message[] }): Promise< { output?: { message_id?: string }[], success?: boolean, error?: any[] }> {
    if(!this._messages_write) { 
      this._messages_write = this.injector.get(FootprintEdi_messages_writeService);
    }
    return this._messages_write.run($inParams);
  }
   
   

   
 
  private _rabbit_mq_push: FootprintEdi_rabbit_mq_pushService;
  public async rabbit_mq_push($inParams: { egress_id?: string, transaction_id?: string, integration_id?: string, exchange?: string, contract?: string, message?: { Payload?: string, TransactionSet?: string, InboundTransactionId?: string, OutboundTransactionId?: string, Content?: string, Filters?: any } }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._rabbit_mq_push) { 
      this._rabbit_mq_push = this.injector.get(FootprintEdi_rabbit_mq_pushService);
    }
    return this._rabbit_mq_push.run($inParams);
  }
   
   

   
 
  private _sftp_pull: FootprintEdi_sftp_pullService;
  public async sftp_pull($inParams: { connection: string, source_path: string, archive_path?: string, error_path?: string, file_extension?: string, file_name?: string, sort_asc?: boolean, transaction_id?: string }): Promise< { messages?: any[], success?: boolean, files?: { file_name?: string, file_blob?: any }[] }> {
    if(!this._sftp_pull) { 
      this._sftp_pull = this.injector.get(FootprintEdi_sftp_pullService);
    }
    return this._sftp_pull.run($inParams);
  }
   
   

   
 
  private _sftp_push: FootprintEdi_sftp_pushService;
  public async sftp_push($inParams: { connection: string, target_path: string, transit_path?: string, transaction_id?: string, files: { file_name?: string, file_blob?: any }[] }): Promise< { messages?: any[], success?: boolean }> {
    if(!this._sftp_push) { 
      this._sftp_push = this.injector.get(FootprintEdi_sftp_pushService);
    }
    return this._sftp_push.run($inParams);
  }
   
   

   
 
  private _uom_convert: FootprintEdi_uom_convertService;
  public async uom_convert($inParams: { owner: string, project: string, material: string, from_uom: string, from_quantity: number, to_uom?: string, to_default?: boolean }): Promise< { to_quantity?: number }> {
    if(!this._uom_convert) { 
      this._uom_convert = this.injector.get(FootprintEdi_uom_convertService);
    }
    return this._uom_convert.run($inParams);
  }
   
   

   
 
  private _uom_read: FootprintEdi_uom_readService;
  public async uom_read($inParams: { owner: string, project: string, material: string }): Promise< { uoms?: $frontendTypes.FootprintEdi.Uom[] }> {
    if(!this._uom_read) { 
      this._uom_read = this.injector.get(FootprintEdi_uom_readService);
    }
    return this._uom_read.run($inParams);
  }
   
   

   
 
  private _uom_tests: FootprintEdi_uom_testsService;
  public async uom_tests($inParams: {  }): Promise< { results?: any[] }> {
    if(!this._uom_tests) { 
      this._uom_tests = this.injector.get(FootprintEdi_uom_testsService);
    }
    return this._uom_tests.run($inParams);
  }
   
   

   
 
  private _uom_write: FootprintEdi_uom_writeService;
  public async uom_write($inParams: { uoms: $frontendTypes.FootprintEdi.Uom[] }): Promise< { uoms?: $frontendTypes.FootprintEdi.Uom[], results?: any[] }> {
    if(!this._uom_write) { 
      this._uom_write = this.injector.get(FootprintEdi_uom_writeService);
    }
    return this._uom_write.run($inParams);
  }
   
   

   
}
